"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
require("./styles/skeleton-table.scss");
/**
 * Table skeleton with multiple shimmer rows
 */
var SkeletonTable = function (_a) {
    var _b = _a.rows, rows = _b === void 0 ? 5 : _b, className = _a.className;
    return (react_1.default.createElement("div", { className: "skeleton-table " + (className || "") }, Array.from({ length: rows }).map(function (_, index) { return (react_1.default.createElement("div", { key: index, className: "skeleton-table-row" },
        react_1.default.createElement(office_ui_fabric_react_1.Shimmer, null),
        react_1.default.createElement("br", null))); })));
};
exports.default = SkeletonTable;
